import { styled } from '@nx-kit/styling';

export const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  right: 15px;
  bottom: 15px;
  background: ${(props) => props.theme.global.color.primary};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  border-radius: 90px;
  color: ${(props) => props.theme.global.color.white};
  z-index: ${({ theme }) => theme.global.zIndex.guideQrScanButton};
  cursor: pointer;
`;

export const ButtonLabel = styled.div`
  font-weight: 700;
  font-size: 11px;
  line-height: 100%;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-top: 8px;
`;
